<c-offcanvas
  *ngIf="snapshot"
  placement="end"
  id="OffcanvasStart"
  style="min-width: 680px; overflow-y: auto;"
  [visible]="visible"
  (visibleChange)="visibleChange.emit($event)"
>
  <c-offcanvas-header>
    <h2 cOffcanvasTitle class="d--f">Utilisation Activity - {{snapshot.vehicle_registration_field }}</h2>
  </c-offcanvas-header>
  <c-offcanvas-body>
    
    <aside>
      <!-- <pre>isLoading: {{isLoading}}</pre> -->
       <!-- <pre>{{snapshot | json}}</pre> -->
     <!-- <pre>{{vehicleUtilizationLastEventMeta | json}}</pre>
      <pre>{{ vehicleUtilizationLastEventMeta?._current_vor_activities &&  snapshot.is_vor }}</pre> -->
      <h6>Current utilisation status: 
        <c-badge [color]="getUtilisationBadgeColour(snapshot.is_utilized, snapshot.is_vor)">
          {{ getUtilisationStatus(snapshot)}}
        </c-badge>
      </h6>
      
      <div class="vor-activities" *ngIf="vehicleUtilizationLastEventMeta && snapshot.is_vor">
        <h6 class="vor-activities__title">VOR Activities currently causing Unused 
          <c-badge [color]="getUtilisationBadgeColour(snapshot.is_utilized, snapshot.is_vor)">
            {{ getUtilisationStatus(snapshot)}}
          </c-badge> Status:
        </h6>
        <!-- VOR Events Accordions -->
        <c-accordion *ngIf="vehicleUtilizationVorEvents">
          <c-accordion-item
            [visible]="false"
            #item="cAccordionItem"
            *ngFor="let activity of vehicleUtilizationVorEvents"
          >
            <ng-template cTemplateId="accordionHeaderTemplate">
              <button (click)="item.toggleItem(); loadVorEventDetails(activity)" [collapsed]="!item.visible" cAccordionButton>
                {{ activity.activity_type }}
              </button>
            </ng-template>
            <ng-template cTemplateId="accordionBodyTemplate">
              <div class="accordion-body">
                <div class="spinner-container" *ngIf="activity.details === null">
                  <c-spinner class="spinner" />
                </div>
                <div *ngIf="activity.details !== null">
                  <p>Description: {{ activity.details?.description }}</p>
                  <p>Status: {{ activity.details?.status_display }}</p>
                  <p>Record ID: {{ activity.details?.record_id }}</p>
                  <p>Raw Status: {{ activity.details?.status }}</p>
                </div>
              </div>
            </ng-template>
          </c-accordion-item>
        </c-accordion>
        <!-- <pre>vehicleUtilizationLastEventMeta: </pre>
        <pre>{{vehicleUtilizationLastEventMeta | json }}</pre> -->
      </div>
    </aside>

    <div class="divider"><hr /></div>

    <div class="utilisation-events-list-container">
      <h5>Vehicle Utilisation Events</h5>
      @if (isLoading) {
        <div class="spinner-container" *ngIf="isLoading">
          <c-spinner class="spinner" />
        </div>
      } 
      @else if (vehicleUtilizationEvents.length > 0) {
        <table datatable class="table table-striped">
          <thead>
            <tr>
              <!-- <th>id</th> -->
              <th>Ref</th>
              <th>Reason</th>
              <th>Utilisation Type</th>
              <th>Event Create date</th>
              <!-- <th>Utilization Snapshot</th> -->
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let event of vehicleUtilizationEvents" cOffcanvasToggle="OffcanvasEnd">
              <td>{{getReferenceObjectType(event.reference_object_type)}}</td>
              <td>{{ event?.notes }}</td>
              <td>{{getUtilisationChangeType(event.utilization_change_type)}}</td>
              <td>{{ event?.created_at | date: 'dd-MM-yyyy HH:mm' }}</td>
            </tr>
          </tbody>
        </table>
      } 
      @else {
        <c-callout color="info">
          There are no utilisation events for this vehicle on this date
        </c-callout>
      }

    </div>
   
   

    <div class="divider"><hr /></div>
      <!-- Manual Status Post Form Section -->
      <div class="d--f d-md-flex justify-content-md-end">
        <button (click)="toggleCollapse()" cButton class="me-1 d--f jc--c manual-event-toggle" variant="outline" size="sm" color="primary">Add a Manual Utilisation Event 
          <svg class="manual-event-toggle__icon"  [ngClass]="{'rotate': manualEventAddPanelShow}" cIcon name="cilPlus" size="lg" title="Paper Plane Icon"></svg>
         </button>
         
      </div>

      <div class="manual-event" [visible]="manualEventAddPanelShow" cCollapse>
        <c-card>
          <c-card-header>
            <h5 class="manual-event__title">Manually Add a Utilisation Event</h5>
          </c-card-header>
          <c-card-body>
            <p cCardText>
              If you think the vehicle has had additional utilisation events. You can add manual utilisation events below.
            </p>
            <form (ngSubmit)="onUpdateStatus()" class="d--f ai--fe mb-4 manual-event__form" >
              <!-- First Input -->
              <div class="me-2">
                <label for="status" class="form-label">Utilisation Status:</label>
                <select id="status" class="form-control select" name="status" [(ngModel)]="status" placeholder="Select a status..." required>
                  <option value="-1" selected>Please select...</option> 
                  <option *ngIf="permissions.hasRolePermission('is_customer_admin')" [ngValue]="0">Used</option>
                  <option *ngIf="permissions.hasRolePermission('is_customer_admin')" [ngValue]="1">Unused</option>
                  <option *ngIf="permissions.hasRolePermission('is_customer_admin')" [ngValue]="3">Available (UnVOR)</option>
                  <option [ngValue]="2">No-Change</option>
                </select>
              </div>
        
              <div class="me-2 fg--1">
                <label for="notes" class="form-label">Reason:</label>
                <!-- <input type="text" id="notes" class="form-control" [(ngModel)]="notes" name="notes" required /> -->
                <select id="notes" class="form-control select" name="notes" [(ngModel)]="notes" placeholder="Select a manual reason..." required>
                  <option value="" selected>Please select...</option>
                  <option *ngFor="let option of reasonsList" [value]="option.display_name"
                    [selected]="option.display_name === notes">
                    {{ option.display_name }}
                  </option>
                </select>
              </div>
              <!-- <pre>reasonsList: {{reasonsList | json }}</pre> -->
        
              <!-- Submit Button -->
              <div>
                <button type="submit" [disabled]="isLoading || status === -1 || notes == ''" class="btn btn-primary manual-event__submit">Submit</button>
              </div>
             
            </form>

        
          </c-card-body>
        </c-card>
       
      </div>
     
     

  </c-offcanvas-body>
</c-offcanvas>
